import { InputBase } from '@mui/material'
import styles from './ThreadListRow.module.scss'

export default function ThreadListRowTitleEdit({
  titleInputRef,
  draftTitle,
  setDraftTitle,
  commitRename,
  cancelRename,
}) {
  return (
    <InputBase
      inputRef={titleInputRef}
      value={draftTitle}
      onChange={(e) => setDraftTitle(e.target.value)}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault()
          commitRename()
        } else if (e.key === 'Escape') {
          e.preventDefault()
          cancelRename()
        }
      }}
      onBlur={commitRename}
      inputProps={{ 'aria-label': 'Thread name' }}
      className={styles.titleInputBase}
      slotProps={{ input: { className: styles.titleInput } }}
    />
  )
}
